export default __webpack_public_path__ + "static/media/start.584babde.png";